import { render } from "./recipientsContents.vue?vue&type=template&id=a8137a54&scoped=true"
import script from "./recipientsContents.vue?vue&type=script&lang=js"
export * from "./recipientsContents.vue?vue&type=script&lang=js"

import "./recipientsContents.vue?vue&type=style&index=0&id=a8137a54&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8137a54"]])

export default __exports__